const valorAtivo = (valor) =>
  valor === true || valor === 1 || valor === '1' || String(valor).toLowerCase() === 'true';

export const estaOnline = (status) => valorAtivo(status);

export const obterMotivoBloqueioComando = ({ tanque, bomba, statusTanque, statusGtw }) => {
  if (!estaOnline(statusTanque) && !estaOnline(statusGtw)) {
    return 'Comando bloqueado: o tanque e o gateway estão offline.';
  }

  const painel = Number(tanque?.painel);
  const controleIndividualDaBomba = painel === 1 || painel === 3;
  const automatico = controleIndividualDaBomba ? bomba?.automatico : tanque?.automatico;

  if (!valorAtivo(automatico)) {
    return controleIndividualDaBomba
      ? 'Comando bloqueado: coloque esta bomba em modo automático.'
      : 'Comando bloqueado: coloque o painel em modo automático.';
  }

  return null;
};
